<template>
<div>
  <add-heading :title="this.$t('profile.experience')" v-on:add="addClicked" :label="this.$t('profile.add')" :stepped="false" />
  <div class="cards">
    <experience-card :experience="null" v-on:add="addClicked"
    v-if="experiences.length === 0" />
    <experience-card v-for="experience in experiences"
      v-on:edit="editClicked(experience)"
      :key="experience.id"
      :experience="experience"
      class="experience-card" />
  </div>
</div>
</template>

<script>
import ExperienceCard from '@/components/profile/experience-row-card'
import AddHeading from '@/components/general/add-heading'
import { mapState, mapActions } from 'vuex'

export default {
  components: { ExperienceCard, AddHeading },
  methods: {
    addClicked () {
      this.$emit('add')
    },
    editClicked (experience) {
      this.$emit('edit', experience)
    },
    ...mapActions('experience', [
      'getExperiences'
    ])
  },
  computed: {
    ...mapState('experience', [
      'experiences'
    ])
  },
  async mounted () {
    await this.getExperiences()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.experience-card:not(:last-child) {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.experience-card:not(:first-child) {
  border-top: 0;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.experience-card:hover {
  background-color: $hover-background;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/experience-section.vue